const action = (type, payload, meta) => ({ type, payload, meta });

export default action;
